var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container row-center ais fww"},[_c('small',[_vm._v("© Universidad Francisco de Vitoria "+_vm._s(new Date().getFullYear()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }